import { Drawer, DrawerContent } from '@/components/ui/drawer';
import { SheetHeader } from '@/components/SheetHeader';
import { listDeviceBookings } from '@/lib/device-bookings';
import { useStudio } from '@/features/studio/studio-data';
import { useBookingNav } from '@/features/booking/useBookingNav';
import { AssistantChat } from './AssistantChat';
import { clientSuggestions } from './suggestions';
import { useAssistantNav } from './useAssistantNav';

/** «Помощник студии» as a bottom sheet over any client page (?ask=1[&q=…]). */
export function AssistantSheet() {
  const studio = useStudio();
  const assistant = useAssistantNav();
  const booking = useBookingNav();
  if (!studio.aiEnabled) return null;
  // Lets the assistant answer "когда моя запись?" for the latest booking on this device.
  const latestToken = listDeviceBookings(studio.slug)[0]?.token ?? null;

  return (
    <Drawer showSwipeHandle open={assistant.isOpen} onOpenChange={(next) => !next && assistant.close()}>
      <DrawerContent data-testid="assistant-sheet" className="data-[swipe-axis=y]:inset-x-[max(0px,calc((100vw-640px)/2))]">
        <SheetHeader title="Помощник студии" description={`Помощник студии ${studio.name}`} onClose={assistant.close} />
        <div className="sheet-body">
          {assistant.isOpen ? (
            <AssistantChat
              slug={studio.slug}
              scope="client"
              suggestions={clientSuggestions(studio.services)}
              initialQuestion={assistant.question}
              bookingToken={latestToken}
              onBook={(serviceId) => booking.open(serviceId)}
              serviceName={(serviceId) => studio.services.find((s) => s.id === serviceId)?.name}
              intro="Услуги, цены и свободное время — отвечаю по расписанию студии и ничего не придумываю."
            />
          ) : null}
        </div>
      </DrawerContent>
    </Drawer>
  );
}
